import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { to: '/', label: '首页' },
    { to: '/category/premium-residence', label: '精品居住' },
    { to: '/category/quality-service', label: '优质服务' },
    { to: '/category/member-privilege', label: '会员权益' },
    { to: '/category/lifestyle-guide', label: '生活指南' },
  ],
  service: [
    { to: '/about', label: '关于我们' },
    { to: '/about', label: '品牌故事' },
    { to: '/about', label: '会员口碑' },
    { to: '/about', label: '联系我们' },
    { to: '/about', label: '入驻指南' },
  ],
  articles: [
    { to: '/article/city-center-villa-guide', label: '别墅选购指南' },
    { to: '/article/butler-service-experience', label: '管家服务体验' },
    { to: '/article/luxury-real-estate-2026', label: '地产投资前瞻' },
    { to: '/article/home-aesthetics-2026', label: '家居美学趋势' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-xl font-heading font-bold text-background-50 tracking-wide">
                精品八区
              </span>
            </Link>
            <p className="mt-4 text-sm text-background-400 leading-relaxed">
              汇聚高端精选资源与优质生活体验，为追求品质的您提供一站式尊享解决方案。
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-background-50 hover:bg-accent-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-background-50 hover:bg-accent-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:text-background-50 hover:bg-accent-500 transition-colors duration-200 cursor-pointer" aria-label="小红书">
                <i className="ri-red-packet-line text-lg" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">服务支持</h4>
            <ul className="space-y-2.5">
              {footerLinks.service.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">精品文章</h4>
            <ul className="space-y-2.5">
              {footerLinks.articles.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 精品八区 Premium District. 保留所有权利。
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">会员协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}